/**
 * As cidades atendidas, agrupadas por região.
 *
 * Todo o texto aqui foi tirado das próprias páginas de cidade (heroSubtitle ou
 * meta description) — nada foi escrito de novo. Ao criar uma página de cidade
 * nova, acrescente-a aqui para que ela apareça no índice.
 */
export interface CidadeResumo {
  rota: string;
  nome: string;
  uf: string;
  descricao: string;
}

export interface GrupoDeCidades {
  regiao: string;
  chamada: string;
  cidades: CidadeResumo[];
}

export const CIDADES_POR_REGIAO: GrupoDeCidades[] = [
  {
    regiao: 'São Paulo',
    chamada: 'Capital, ABC, interior e litoral — nossa base de operação.',
    cidades: [
      {
        rota: '/sao-paulo',
        nome: 'São Paulo',
        uf: 'SP',
        descricao:
          'Fones sem fio para congressos, feiras, summits e eventos corporativos. Expo Center Norte, WTC, Rebouças e toda a Grande SP.',
      },
      {
        rota: '/campinas',
        nome: 'Campinas',
        uf: 'SP',
        descricao:
          'Maior polo tecnológico do interior paulista, com equipamentos e profissionais presentes na cidade para eventos corporativos, conferências multilíngues e workshops.',
      },
      {
        rota: '/barueri',
        nome: 'Barueri e Alphaville',
        uf: 'SP',
        descricao:
          'O maior centro empresarial da América Latina, com suporte técnico de alto nível para eventos corporativos.',
      },
      {
        rota: '/ribeirao-preto',
        nome: 'Ribeirão Preto',
        uf: 'SP',
        descricao:
          'Capital do agronegócio e polo de saúde, com suporte técnico especializado para conferências e workshops.',
      },
      {
        rota: '/sao-jose-dos-campos',
        nome: 'São José dos Campos',
        uf: 'SP',
        descricao:
          'Capital da indústria aeroespacial, com suporte técnico de alta precisão para eventos corporativos e conferências.',
      },
      {
        rota: '/sao-bernardo-do-campo',
        nome: 'São Bernardo do Campo',
        uf: 'SP',
        descricao:
          'Berço da indústria automobilística, com expertise em eventos corporativos no ABCD Paulista.',
      },
      {
        rota: '/santos',
        nome: 'Santos',
        uf: 'SP',
        descricao:
          'Principal cidade portuária do Brasil, com suporte técnico especializado para eventos corporativos e conferências.',
      },
      {
        rota: '/guarulhos',
        nome: 'Guarulhos',
        uf: 'SP',
        descricao:
          'Segunda maior cidade de SP e hub logístico estratégico, com a proximidade do aeroporto internacional a favor do seu evento.',
      },
      {
        rota: '/jundiai',
        nome: 'Jundiaí',
        uf: 'SP',
        descricao:
          'Polo logístico estratégico e hub de distribuição, com suporte técnico especializado para eventos corporativos.',
      },
    ],
  },
  {
    regiao: 'Rio de Janeiro e Minas',
    chamada: 'Congressos, eventos corporativos e grandes públicos.',
    cidades: [
      {
        rota: '/rio-de-janeiro',
        nome: 'Rio de Janeiro',
        uf: 'RJ',
        descricao:
          'Áudio sem fio para congressos, eventos corporativos, festivais e shows. Equipamentos e profissionais presentes na cidade, múltiplos canais simultâneos e técnico no local.',
      },
      {
        rota: '/belo-horizonte',
        nome: 'Belo Horizonte',
        uf: 'MG',
        descricao:
          'Tecnologia premium para congressos médicos, feiras e eventos corporativos no Expominas e no Minascentro. Até 4 trilhas simultâneas.',
      },
    ],
  },
  {
    regiao: 'Brasília e Centro-Oeste',
    chamada: 'Eventos governamentais, diplomáticos e licitações.',
    cidades: [
      {
        rota: '/brasilia',
        nome: 'Brasília',
        uf: 'DF',
        descricao:
          'Tecnologia premium para eventos governamentais, conferências diplomáticas e corporativos. Tradução simultânea em 3 idiomas e nota fiscal para licitação.',
      },
    ],
  },
  {
    regiao: 'Sul',
    chamada: 'Eventos de tecnologia, agronegócio e indústria.',
    cidades: [
      {
        rota: '/curitiba',
        nome: 'Curitiba',
        uf: 'PR',
        descricao:
          'Áudio sem fio para eventos tech, agro e corporativos. Expo Unimed, Bourbon Convention e toda a região metropolitana.',
      },
      {
        rota: '/porto-alegre',
        nome: 'Porto Alegre',
        uf: 'RS',
        descricao:
          'Inovação gaúcha, atendida com equipe e equipamentos que se deslocam de São Paulo para eventos corporativos, conferências e workshops.',
      },
    ],
  },
  {
    regiao: 'Nordeste',
    chamada: 'Convenções, conferências multilíngues e treinamentos.',
    cidades: [
      {
        rota: '/recife',
        nome: 'Recife',
        uf: 'PE',
        descricao:
          'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Recife e Pernambuco, com equipamentos e profissionais presentes na cidade.',
      },
      {
        rota: '/salvador',
        nome: 'Salvador',
        uf: 'BA',
        descricao:
          'Palestra silenciosa com suporte técnico especializado para eventos corporativos e conferências multilíngues na Bahia.',
      },
      {
        rota: '/fortaleza',
        nome: 'Fortaleza',
        uf: 'CE',
        descricao:
          'Palestra silenciosa com suporte técnico especializado para eventos corporativos, conferências e workshops no Ceará.',
      },
      {
        rota: '/aracaju',
        nome: 'Aracaju',
        uf: 'SE',
        descricao:
          'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Aracaju.',
      },
      {
        rota: '/natal',
        nome: 'Natal',
        uf: 'RN',
        descricao:
          'Tecnologia de áudio sem fio premium para eventos corporativos, conferências multilíngues e workshops em Natal.',
      },
    ],
  },
];

export const TODAS_AS_CIDADES: CidadeResumo[] = CIDADES_POR_REGIAO.flatMap((g) => g.cidades);
